<template>
  <div>
    <div class="col-sm-12 col-xs-12 col-md-12">
      <hr />
    </div>
    <div class="col-sm-12 col-xs-12 box-wrapper">
      <div class="col-xs-12 col-sm-6 col-sm-push-6">
        <div class="unrestrict-button">
          <button
            class="btn emergo-red-button"
            @click="openConfirmationPopup()"
            v-if="member.is_restricted"
          >
            UnBlock
          </button>
        </div>
        <div class="col-xs-12 col-sm-10 img-blk p-0">
          <div class="profile-pic-edit profile-pic-title-edit" v-if="!member.profile_pic">
            {{ getInitials(member.first_name, member.last_name) }}
          </div>
          <img
            class="profile-pic-edit"
            v-if="member.profile_pic"
            :src="member.profile_pic"
            alt="profile-icon"
          />
          <div>
            <p class="warn-restriction" v-if="member.is_restricted">
              You cannot edit the details as Team Member is blocked.
            </p>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-sm-pull-6 col-xs-12">
        <div class="row mr-bt-5p">
          <div class="col-sm-12 col-xs-12 col-md-12 form-group">First Name</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              placeholder="Name"
              :value="member.first_name"
              class="form-control"
              disabled
            />
          </div>
        </div>
        <div class="row mr-bt-5p">
          <div class="col-sm-12 col-xs-12 col-md-12 form-group">Last Name</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              placeholder="Name"
              :value="member.last_name"
              class="form-control"
              disabled
            />
          </div>
        </div>
        <div class="row mr-bt-5p">
          <div class="col-sm-12 col-xs-12 col-md-12 form-group">Email</div>
          <div class="col-sm-12 col-xs-12 col-md-10 mb-10">
            <input
              type="text"
              placeholder="Email"
              :value="member.email"
              class="form-control"
              disabled
            />
          </div>
        </div>
        <div
          class="row"
          :class="displayIpErrorMsg ? 'mr-bt-0p' : 'mr-bt-5p'"
          v-if="multi_factor_key"
        >
          <div class="col-sm-12 col-xs-12 col-md-12 form-group">IP Address</div>
          <div class="col-sm-12 col-xs-12 col-md-10 mb-10">
            <input
              type="text"
              placeholder="IP Address (xxx.xxx.xxx.xxx)"
              class="form-control"
              :class="displayIpErrorMsg ? 'invalid-border' : ''"
              v-model="ipAddress"
              @blur="ipAddressVal"
              :disabled="member.is_restricted"
            />
            <div v-if="displayIpErrorMsg" class="custom-error-class">
              <span>Invalid IP Address.</span>
            </div>
          </div>
        </div>
        <div class="row mr-bt-5p">
          <div class="col-sm-12 col-xs-12 col-md-12 form-group">Role</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <div class="custom-dropdown mt-4">
              <multiselect
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="multiselect-single-dropdown"
                :searchable="false"
                :options="roles.map((role) => role.id)"
                :custom-label="getRoleNameById"
                v-model="roleId"
                @input="getRoleBasedTemplate(roleId)"
                placeholder="Select Role"
              >
              </multiselect>
            </div>
          </div>
        </div>
        <div class="row mr-bt-5p" v-if="roleId == 6">
          <div class="col-sm-12 col-xs-12 col-md-12">Distributor</div>
          <div class="col-sm-12 col-xs-12 col-md-10 custom-dropdown">
            <multiselect
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              :searchable="false"
              :options="distributors.map((distributor) => distributor.id)"
              :custom-label="(option) => distributors.find((x) => x.id === option).distributor_name"
              v-model="distributorId"
              placeholder="Select Role"
            >
            </multiselect>
          </div>
        </div>
      </div>
      <div
        class="col-md-12 col-sm-12 col-xs-12 pb-20"
        v-if="userServiceList && userServiceList.length"
      >
        <div class="col-md-12 col-sm-12 col-xs-12 pl-0 pr-0 bt-border">
          <div class="row pb-4">
            <div class="col-sm-7 col-xs-6">Services access</div>
            <div class="col-sm-3 col-xs-6 txt-alg-rt">Permissions</div>
          </div>
        </div>
        <div
          v-for="(service, index) in userServiceList"
          :key="index"
          class="col-md-12 col-sm-12 col-xs-12 bt-border"
        >
          <div class="row pb-8 pt-8" v-if="service.key != 'REPRESENTATION_RESOURCES' || account_type_id != 3">
            <div class="col-sm-7 col-xs-8 d-flex align-items-center">
              <span
                class="checkbox mr-12"
              >
                <label>
                  <input
                    type="checkbox"
                    v-model="service.access"
                    :disabled="member.is_restricted || !disablePermissionCheck(service.id)"
                    @change="revertOldPermissions(service.id, service.access)"
                  />
                  <span class="cr"></span>
                </label>
              </span>
              <span
                class="cust_label"
                :class="{
                  'link-disabled': member.is_restricted || !disablePermissionCheck(service.id)
                }"
              >
                {{ service.name }}
              </span>
            </div>
            <div class="col-sm-3 col-xs-4">
              <div
                class="edit-lnk"
                @click="
                  disablePermissionCheck(service.id) && service.access
                    ? openPermissionsPopup(service)
                    : null
                "
                :class="{
                  'link-disabled':
                    member.is_restricted || !disablePermissionCheck(service.id) || !service.access
                }"
              >
                edit
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-sm-12 col-xs-12 col-md-12 footer remove_button_padding"
      v-if="!member.is_restricted"
    >
      <div class="col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0">
        <button type="button" class="btn btn-block emergo-white-button" @click="cancelEditTeam">
          Cancel
        </button>
      </div>
      <div class="col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0">
        <button
          type="button"
          class="btn btn-block emergo-green-button"
          @click="updateTeamMember()"
          :disabled="disableButtonForAddTeam || loaderStatus"
        >
          Save Changes
        </button>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-12 footer remove_button_padding" v-else>
      <div
        class="col-sm-offset-9 col-md-offset-10 col-xs-offset-7 col-md-2 col-sm-3 col-xs-5 xs-pd-lt-0"
      >
        <button type="button" class="btn btn-block emergo-white-button" @click="cancelEditTeam">
          Cancel
        </button>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <member-permissions
      :member="member.first_name + ' ' + member.last_name"
      :serviceId="serviceId"
      :userServiceList="userServiceList"
      :rolesServicesList="servicesList"
      @updateUserPermission="updateUserPermission"
    >
    </member-permissions>
    <div id="confirmaton_popup" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header confirmpopup-bgcolor">
            <button
              type="button"
              class="close"
              data-toggle="modal"
              data-target="#confirmaton_popup"
            >
              &times;
            </button>
            <h4 class="modal-title">Are you sure you want to unblock the member?</h4>
            <p class="user-name">{{ member.email }}</p>
            <p class="unblock-modal-content">
              By unblocking this user, you will utilize one (1) available Team Member subscription.
              The user will regain all previous access levels.
            </p>
          </div>
          <div class="modal-footer confirmpopup-bgcolor">
            <div class="col-sm-6 col-xs-12 txt-alg-rt">
              <button
                type="button"
                class="btn emergo-white-button btn-width-confirm"
                data-toggle="modal"
                data-target="#confirmaton_popup"
              >
                Cancel
              </button>
            </div>
            <div class="col-sm-6 col-xs-12 text-left">
              <button
                type="button"
                class="btn emergo-green-button btn-width-confirm"
                @click="updateTeamMemberRestriction()"
              >
                Yes, unblock user
              </button>
            </div>
          </div>
          <loader :loadingStatus="confirmLoaderStatus"></loader>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import _ from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import Loader from '../../UIComponents/Loader.vue';
import EventBus from '../../../utils/event-bus';
import MemberPermissions from './MemberPermissions.vue';
import { getRoleBasedPermissions, getUserPermissions } from '../../../apis/rbac';

import { getActiveServices } from '../../../apis/marketPlace';
import {
  updateTeamMember,
  updateTeamMemberRestriction,
  getAccountOwnersCount
} from '../../../apis/team';
import { isDefaultDashboard, setDefaultPreference } from '../../../apis/dashboardCustomization';
import { isDefaultAvailable } from '../../../apis/regulatoryIntelligence';

export default {
  props: [
    'member',
    'roles',
    'distributors',
    'getTeamMembers',
    'cancelAddTeam',
    'multi_factor_key',
    'account_type_id'
  ],
  components: {
    Loader,
    MemberPermissions
  },
  data() {
    return {
      displayIpErrorMsg: false,
      loaderStatus: false,
      Permissions: '',
      servicesList: [],
      serviceId: '',
      userServiceList: [],
      usersPermission: {},
      roleId: null,
      distributorId: null,
      ipAddress: null,
      confirmLoaderStatus: false
    };
  },
  async created() {
    await this.getPermissionsList();
    this.roleId = this.member.role_id;
    this.distributorId = this.member.assigned_distributor_id;
    this.ipAddress = this.member.ip_address;
    EventBus.$on('resetTeams', () => {
      this.cancelEditTeam();
    });
  },
  computed: {
    disableButtonForAddTeam() {
      if (this.roleId === 6 && !this.distributorId) return true;
      if (this.member.role_id !== this.roleId) return false;
      if (this.member.ip_address !== this.ipAddress) {
        const ipAddressFormat =
          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; //eslint-disable-line
        if (this.ipAddress && this.ipAddress.match(ipAddressFormat)) {
          return false;
        }
      }
      if (this.member.role_id === this.roleId) {
        if (this.distributorId !== this.member.assigned_distributor_id) return false;
        let diff = true;
        for (let i = 0; i < this.userServiceList.length; i += 1) {
          const obj2 = this.usersPermission.services.find(
            (service) => service.id === this.userServiceList[i].id
          );
          if (!_.isEqual(this.userServiceList[i], obj2)) {
            diff = false;
            break;
          }
        }
        return diff;
      }
      return true;
    }
  },
  watch: {
    roleId() {
      if (this.roleId === 6 && this.roleId === this.member.role_id)
        this.distributorId = this.member.assigned_distributor_id;
      else this.distributorId = null;
    }
  },
  beforeDestroy() {
    EventBus.$off('resetTeams');
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    removeNull(array) {
      return array.filter((item) => item);
    },
    openConfirmationPopup() {
      $('#confirmaton_popup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    async updateTeamMemberRestriction() {
      const check =
        this.account_type_id !== 1 &&
        this.account_type_id !== 5 &&
        (this.roleId === 1 || this.roleId === 9)
          ? await this.checkAccountOwnersCount()
          : true;
      if (check) {
        const data = {
          action: 'unrestrict',
          role_id: this.member.role_id,
          user_id: this.member.user_id
        };
        this.confirmLoaderStatus = true;
        const response = await updateTeamMemberRestriction(data);
        this.confirmLoaderStatus = false;
        if (response && response.status) {
          this.$emit('getTeamMembers');
          this.cancelEditTeam();
          this.clearNotifications();
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Team member restriction updated successfully!',
            group: 'custom-notification'
          });
        } else {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text:
              response && !response.status
                ? response.message
                : 'Team member restriction update failed!',
            group: 'custom-notification'
          });
        }
      }
    },
    ipAddressVal() {
      const ipAddressFormat =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; //eslint-disable-line
      this.displayIpErrorMsg = false;
      if (this.ipAddress && !this.ipAddress.match(ipAddressFormat)) {
        this.displayIpErrorMsg = true;
      }
    },
    revertOldPermissions(id, access) {
      if (!access) {
        let service;
        if (this.roleId === this.member.role_id) {
          service = this.usersPermission.services.find((s) => s.id === id);
        } else {
          service = this.servicesList.find((s) => s.id === id);
        }
        this.userServiceList.forEach((s, index) => {
          if (s.id === id) {
            this.userServiceList[index].modules = service.modules;
          }
        });
      }
    },
    disablePermissionCheck(serviceid) {
      return this.servicesList.find((service) => service.id === serviceid).access;
    },
    async updateTeamMember() {
      const check =
        this.account_type_id !== 1 &&
        this.account_type_id !== 5 &&
        this.roleId !== this.member.role_id &&
        (this.roleId === 1 || this.roleId === 9)
          ? await this.checkAccountOwnersCount()
          : true;
      if (!this.disableButtonForAddTeam && check) {
        this.loaderStatus = true;
        const data = {
          assigned_role_id: this.roleId,
          user_role_id: this.member.id,
          rbac_permission_inst: this.userServiceList,
          ip_address: this.ipAddress
        };
        if (this.roleId === 6) data.assigned_distributor_id = this.distributorId;
        const response = await updateTeamMember(data);
        this.loaderStatus = false;
        if (response && response.status) {
          // reset upser preferences to default
          this.loaderStatus = true;
          const isDefault = await isDefaultDashboard(this.member.account_id, this.member.user_id);
          const dashboardData = {
            account_id: this.member.account_id,
            dashboard_notification_type_id: 1,
            user_id: this.member.user_id
          };
          if (!isDefault) {
            await setDefaultPreference(dashboardData);
          }
          this.loaderStatus = false;
          this.clearNotifications();
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Team member updated successfully!',
            group: 'custom-notification'
          });
          this.$emit('getTeamMembers');
          this.cancelEditTeam();
        } else {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text: response.message ? response.message : 'Unable to update Team member!',
            group: 'custom-notification'
          });
        }
      }
    },
    async checkAccountOwnersCount() {
      this.loaderStatus = true;
      this.confirmLoaderStatus = true;
      const response = await getAccountOwnersCount(this.account_type_id);
      this.loaderStatus = false;
      this.confirmLoaderStatus = false;
      if (!response) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to fetch Account Owners Count!',
          group: 'custom-notification'
        });
        return false;
      }
      if (response.count < 5) {
        return true;
      }
      this.clearNotifications();
      this.$notify({
        type: 'error',
        title: 'Error',
        text: 'Maximum 5 account owners can be added!',
        group: 'custom-notification'
      });
      return false;
    },
    updateUserPermission(permissions, serviceId) {
      this.userServiceList.forEach((service, index) => {
        if (service.id === serviceId) {
          this.$set(this.userServiceList, index, permissions);
        }
      });
    },
    cancelEditTeam() {
      this.roleId = null;
      this.distributorId = null;
      this.ipAddress = '';
      this.$emit('cancelAddTeam');
    },
    async getPermissionsList() {
      await this.getRoleBasedTemplate(this.member.role_id);
      this.loaderStatus = true;
      const response = await getUserPermissions(
        this.member.user_id,
        this.member.account_id,
        this.member.role_id
      );
      this.loaderStatus = false;
      if (response && response.services) {
        // Remove null from response
        const updatedResponse = this.removeNull(response.services).map((x) => ({
          ...x,
          modules: this.removeNull(x.modules).map((m) => ({
            ...m,
            operations: this.removeNull(m.operations)
          }))
        }));
        response.services = updatedResponse;
        if (this.account_type_id === 3) {
          response.services = response.services.map((service) => {
            if (service.key === 'REPRESENTATION_RESOURCES') service.access = false;
            return service;
          });
        }
        this.usersPermission = response;
        this.userServiceList = cloneDeep(this.usersPermission.services);
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to get user permissions!',
          group: 'custom-notification'
        });
      }
    },
    getInitials(firstname, lastname) {
      return `${firstname ? firstname.charAt(0).toUpperCase() : ''}${
        lastname ? lastname.charAt(0).toUpperCase() : ''
      }`;
    },
    openPermissionsPopup(service) {
      this.serviceId = service.id;
      setTimeout(() => {
        $('#permissionsAccess').modal({
          backdrop: 'static',
          keyboard: false
        });
      }, 0);
    },
    async getRoleBasedTemplate(roleId) {
      await this.getSubscribedPlans();
      this.loaderStatus = true;
      const response = await getRoleBasedPermissions(roleId);
      this.loaderStatus = false;
      if (response && response.services) {
        // Remove null from response
        const updatedResponse = this.removeNull(response.services).map((x) => ({
          ...x,
          modules: this.removeNull(x.modules).map((m) => ({
            ...m,
            operations: this.removeNull(m.operations)
          }))
        }));
        response.services = updatedResponse;
        response.services.forEach((service, index) => {
          if (service.service_id && !this.addedServiceIds.includes(service.service_id)) {
            response.services[index].access = false;
          }
        });
        this.servicesList = cloneDeep(response.services);
        if (this.roleId === this.member.role_id) {
          this.userServiceList = cloneDeep(this.usersPermission.services);
        } else this.userServiceList = cloneDeep(this.servicesList);
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to get default permissions for the role!',
          group: 'custom-notification'
        });
        this.servicesList = [];
        this.userServiceList = [];
      }
    },
    getRoleNameById(id) {
      const role = this.roles.find((r) => r.id === id);
      return role ? role.name : undefined;
    },
    async getSubscribedPlans() {
      this.loaderStatus = true;
      const accoountServices = await getActiveServices(localStorage.getItem('accountId'));
      this.addedServiceIds = accoountServices.services || [];
      if (!this.addedServiceIds.includes(2)) {
        // Validate when Reg Intel market not active
        const isDefaultMarket = await isDefaultAvailable(localStorage.getItem('accountId'));
        if (isDefaultMarket) {
          this.addedServiceIds.push(2);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.confirmpopup-bgcolor {
  border-radius: 12px;
  background-color: $deep-white;
  border: none;
}
.modal-header {
  .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: unset;
    font-weight: $font-weight-small;
    font-size: $font-30;
  }
}
.warn-restriction {
  color: #c02032;
  margin-top: 15px;
}
.modal-title {
  text-align: center;
  font-size: $font-24;
  margin-bottom: 6px;
  font-weight: $font-weight-400;
  color: $dark-black-alpha;
  margin-top: 14px;
}
.btn-width-confirm {
  width: 230px;
}
.text-left {
  text-align: left;
}
.box-wrapper {
  height: 55vh;
  overflow: auto;
}
.edit-lnk {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: $font-16;
  text-align: right;
  padding-right: 15%;
  color: $messenger-blue;
  cursor: pointer;
}
.mt-4 {
  margin-top: 4px;
}
.txt-alg-rt {
  text-align: right;
}
.cust_label {
  font-size: $font-14;
  color: $primary;
  font-weight: $font-weight-medium;
}
.custom-error-class {
  display: inline-block;
  margin-top: 0px;
}
.bt-border {
  border-bottom: 1px solid $gray74;
}
.profile-pic-edit {
  width: 170px;
  height: 170px;
  line-height: 170px;
  float: unset;
}
.profile-pic-title-edit {
  display: inline-block !important;
  background: #f2f2f2;
  color: #00518a;
}
.mr-bt-5p {
  margin-bottom: 5%;
  padding-bottom: 4px;
}
.mr-bt-0p {
  margin-bottom: 0%;
}
.footer {
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: $white;
}
.img-blk {
  padding-top: 10px;
  text-align: center;
}
.link-disabled {
  opacity: 0.4;
}
.unblock-modal-content {
  font-size: $font-16;
  color: $deep-gray;
  text-align: center;
  padding: 40px 40px 0px 40px;
}
.user-name {
  color: $primary;
  text-align: center;
  font-weight: $font-weight-medium;
  font-size: $font-24;
}
.multiselect-single-dropdown {
  ::v-deep .multiselect__content-wrapper {
    max-height: 270px !important;
  }
}

@media screen and (min-width: 768px) {
  .hide-sm {
    display: none;
  }
  .unrestrict-button {
    position: absolute;
    top: 10px;
    right: 15px;
  }
}
@media screen and (max-width: 767px) {
  .bt-border {
    padding-bottom: 10px;
  }
  .box-wrapper {
    height: 65vh;
    overflow-y: auto;
  }
  .new_member_img {
    height: 100px;
  }
  .footer {
    padding-bottom: 5%;
  }
  .hide-xs {
    display: none;
  }
  .unrestrict-button {
    float: right;
  }
}
@media only screen and (min-width: 1301px) {
  .remove_button_padding {
    padding-left: 230px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .box-wrapper {
    height: 45vh;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  .box-wrapper {
    height: 52vh;
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px) {
  .box-wrapper {
    height: 45vh;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px),
  (device-width: 667px) and (device-height: 375px) {
  .box-wrapper {
    height: 48vh;
  }
}
</style>
